import { render, staticRenderFns } from "./EditMailDesignerView.vue?vue&type=template&id=6ae0d07d"
import script from "./EditMailDesignerView.vue?vue&type=script&lang=js"
export * from "./EditMailDesignerView.vue?vue&type=script&lang=js"
import style0 from "./EditMailDesignerView.vue?vue&type=style&index=0&id=6ae0d07d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports